import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChevronDown, X, Menu } from "lucide-react";
import { useState, useEffect } from "react";
import "./Navbar.css";
import logoNavbar from "../assets/logo_navbar.svg";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  const productOptions = [
    // { name: "Alpha ESS", path: "/product/alpha-ess" },
    // { name: "Growatt", path: "/product/growatt" },
    // { name: "SolaX", path: "/product/solax" },
    // { name: "SOFAR PowerAll", path: "/product/sofar" },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-pill">

        {/* ─── top info bar ─── */}
        <div className="navbar-topbar">
          <div className="navbar-topbar-item">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="rgba(255,255,255,0.9)" />
            </svg>
            <span>sales@wattandwattle.com.au</span>
          </div>
          <div className="navbar-topbar-item">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="rgba(255,255,255,0.9)" />
            </svg>
            <span>1 Wayne Court, Dandenong, VIC, 3175</span>
          </div>
        </div>

        {/* ─── main nav row ─── */}
        <div className="navbar-main-row">

          {/* Logo — left */}
          <Link to="/" className="navbar-logo">
            <img src={logoNavbar} alt="Watt & Wattle" className="logo-image" />
          </Link>

          {/* Mobile hamburger */}
          <button className="navbar-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X size={24} color="white" /> : <Menu size={24} color="white" />}
          </button>

          {/* Nav links — centred */}
          <div className={`navbar-links ${open ? "active" : ""}`}>
            <div
              className={`navbar-dropdown ${dropdownOpen ? "dropdown-open" : ""}`}
              onMouseEnter={() => { if (window.innerWidth > 950) setDropdownOpen(true); }}
              onMouseLeave={() => { if (window.innerWidth > 950) setDropdownOpen(false); }}
            >
              <button
                className={`navbar-product-link ${location.pathname === "/residential-solutions" || location.pathname === "/commercial-solutions" ? "active" : ""}`}
                onClick={() => { if (window.innerWidth <= 950) setDropdownOpen(!dropdownOpen); else navigate('/residential-solutions'); }}
              >
                <span>Solutions</span>
                <ChevronDown size={18} />
              </button>
              <div className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                <Link to="/residential-solutions" className={`dropdown-item${location.pathname === "/residential-solutions" ? " active-item" : ""}`}>Residential Solution</Link>
                <Link to="/commercial-solutions" className={`dropdown-item${location.pathname === "/commercial-solutions" ? " active-item" : ""}`}>Commercial Solution</Link>
              </div>
            </div>

            <Link to="/why-us" className={location.pathname === "/why-us" ? "active" : ""}>Why Us</Link>
            <Link to="/blog" className={location.pathname.startsWith("/blog") ? "active" : ""}>Blog</Link>
            {/* <a href="/#our-works">Our Works</a> */}
            <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}>Contact Us</Link>

            {/* Mobile-only CTA */}
            <Link to="/contact" className="navbar-cta-mobile">Free quote</Link>
          </div>

          {/* CTA buttons — right */}
          <div className="navbar-ctas">
            <a
              href="tel:0414339191"
              className="navbar-phone-btn"
              onClick={(e) => {
                if (typeof window.gtag_phone_report_conversion === 'function') {
                  window.gtag_phone_report_conversion('tel:0414339191');
                }
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#eaff50" />
              </svg>
              <span>0414 339 191</span>
            </a>
            <Link to="/contact" className="navbar-quote-btn">Free quote</Link>
          </div>

        </div>
      </div>
    </nav>
  );
}
